import React from "react";
import styles from "./faq.module.scss";
import ArrowDown from "../../assets/icons/ArrowDown";
import Button, { BTN_VARIANTS } from "../../components/Button";
const FAQ = ({ q = "", children = <></> }) => {
  const [isActive, setIsActive] = React.useState(false);
  return (
    <div className={styles.root}>
      <section className={styles.question}>
        <Button
          variant={BTN_VARIANTS.transparent}
          onClick={() => {
            setIsActive(!isActive);
          }}
          className={styles["question-btn"]}
        >
          <span
            className={`${
              isActive
                ? styles["question-btn-text-active"]
                : styles["question-btn-text"]
            }`}
          >
            {q}
          </span>
          <ArrowDown
            className={`${isActive ? styles["question-btn-chevron"] : ""}`}
            isActive={isActive}
            width="28px"
            height="28px"
          />
        </Button>
      </section>
      <section
        className={`${styles.ans} ${isActive ? styles["ans-active"] : ""}`}
      >
        {children}
      </section>
    </div>
  );
};

export default FAQ;
